<div class="pdf-task" [ngClass]="{ first: first, second: second }">
  <div class="self" (click)="toggle()">
    <div class="title">
      {{ task.description }}
    </div>
    <div class="status">
      <span class="finished" *ngIf="task.finished">DONE</span>
      <span class="running" *ngIf="task.running">RUNNING</span>
      <span class="pending" *ngIf="!task.started">PENDING</span>
    </div>
  </div>
  <div class="sub" *ngIf="task.subtasks.length > 0" [ngClass]="{ open: open }">
    <pdf-task
      *ngFor="let subtask of task.subtasks"
      [task]="subtask"
      [second]="first"
      [open-subtasks]="openSubTasksRecursive"
      [open-subtasks-recursive]="openSubTasksRecursive"></pdf-task>
  </div>
</div>
